<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-body">
        <h1 class="dashboard-panel__title">
          Regras de acordo
        </h1>
        <p class="admin-page-description">
          Regras de renegociação de dívida (acordos) da instituição.
          Defina quantas parcelas, descontos máximos, juros e prazos
          podem ser oferecidos a alunos com débitos em atraso. Use
          "Adicionar regra" pra criar novas configurações.
        </p>
        <agreement-rules-table
          class="dashboard-panel__agreement-rules"
          :agreement-rules="agreementRules"
          @agreement-rule-deleted="deleteAgreementRuleFromIndex($event)"
        />
        <div class="row">
          <div class="col-xs-12 text-right">
            <button class="btn btn-default" @click="showAgreementRuleModal = true">
              Adicionar regra
            </button>
          </div>
        </div>
        <agreement-rule-modal
          v-if="showAgreementRuleModal"
          @agreement-rule-created="addAgreementRule($event)"
          @close="showAgreementRuleModal = false"
        />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .dashboard-panel__agreement-rules {
    margin-bottom: $space-m;
  }
</style>
<script>
import { mapState } from 'vuex';
import AgreementRulesTable from 'components/AgreementRulesTable';
import DebtAgreementRulesService from 'services/DebtAgreementRulesService';
import AgreementRuleModal from './modals/AgreementRuleModal';

export default {
  components: {
    AgreementRuleModal,
    AgreementRulesTable,
  },
  computed: {
    ...mapState([
      'institution',
    ]),
  },
  data() {
    return {
      agreementRules: [],
      showAgreementRuleModal: false,
    };
  },
  mounted() {
    this.$loader.show();
    DebtAgreementRulesService.getDebtAgreementRules(this.institution.id)
      .then((agreementRules) => {
        this.agreementRules = agreementRules;
      })
      .catch(() => {
        this.$alert.notifyAlert('Erro ao buscar informações, tente novamente mais tarde');
      })
      .finally(() => {
        this.$loader.hide();
      });
  },
  methods: {
    deleteAgreementRuleFromIndex(index) {
      this.agreementRules.splice(index, 1);
    },
    addAgreementRule(agreementRule) {
      this.showAgreementRuleModal = false;
      // eslint-disable-next-line no-param-reassign
      agreementRule.newAgreementRule = true;

      const index = this.agreementRules.push(agreementRule) - 1;

      setTimeout(() => {
        this.agreementRules[index].newAgreementRule = false;
      }, 5000);
    },
  },
};
</script>
